import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { FaSave, FaTimes } from 'react-icons/fa';
import { CloseIcon, ColoredGeneratePasswordIcon } from 'ui-component/custom-icons/icons'
import toast from 'react-hot-toast';

import useIsMobile from 'utils/isMobileUtils';
import { CopyToClipboard } from 'react-copy-to-clipboard'; 

// ✅ Clear
const GeneratePasswordModal = ({ openPopup, details, handleSubmit, handleClose }) => {

    const [generatedPassword, setGeneratedPassword] = useState('');

    useEffect(() => {
        initializeData()
    }, []);
    

    const generateNewPassword = () => {
        const value = Math.random().toString(36).slice(-8);
        setGeneratedPassword(value);
    }

    const initializeData = () => {

        if (details) {
            setGeneratedPassword(details || '');
        } else {
            generateNewPassword()
        }
    }

    const isMobile = useIsMobile();
    
   if (!isMobile) return (
        <Modal show={openPopup}  centered size="sm">
            <Modal.Body>
                <div className="p-2">
                    <div>
                        <div className="mb-2 ml-0 pl-0">

                            <div className="row">
                                <div className="col-12 text-center">
                                    <ColoredGeneratePasswordIcon height={'70px'} width={'70px'} />
                                </div>
                            </div>
                            <button className="btn modal-close-icon" onClick={handleClose}>
                                <CloseIcon height={'16px'} width={'16px'} />
                            </button>
                        </div>

                        <div className="row align-items-top form-group">
                            <div className="col-12 text-center ">
                                <div style={{ fontSize: '24px' }}>
                                    Generate Password
                                </div>
                                <div className='textGray'>
                                    <div style={{ padding: '10px' }}>
                                        Generate a compliant, high-strength password for secure access.
                                    </div>
                                
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-top form-group">
                            <div className="col-12">
                                <div style={{ background: '#e0e0e0', borderRadius: '12px', padding: '10px 20px', height: '40px' }}>
                                    <div>
                                        {generatedPassword}
                                    </div>
                                    <CopyToClipboard
                                        text={generatedPassword}
                                        onCopy={() => {
                                            toast.success('Password copied to clipboard!')
                                            handleSubmit(generatedPassword)
                                        }}
                                    >
                                        <div
                                            className="client-portal-notification-modal-content-copy-button"
                                            style={{ cursor: 'pointer', top: '5px' }}
                                        >
                                            Copy
                                        </div>
                                    </CopyToClipboard>
                                    
                                    
                                    
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <button
                                    className="btn btn-main-primary btn-block btn-outlined-main"
                                    onClick={generateNewPassword}
                                    style={{
                                        height: '40px'
                                    }}
                                >
                                    Generate Password
                                </button>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-12">
                                <button
                                    className="btn btn-primary btn-outlined-main-primary btn-block"
                                    style={{
                                        marginBottom: '5px', 
                                        height: '40px'
                                    }}
                                    onClick={() => {
                                        handleSubmit(generatedPassword)
                                    }}
                                >
                                    Use this Password
                                </button>
                            </div>
                        </div>
                        
                        <div className="row">
                            <div className="col-12">
                                <button
                                    className="btn pm-btn-default btn-block"
                                    onClick={() => {
                                        handleClose()
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                        

                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );

    return (
            <div
                className="d-flex"
                style={{
                    width: '100vw',
                    height: '100dvh',
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    zIndex: 20,
                    background: 'rgba(0,0,0,0.07)',
                    justifyContent: 'center',
                    alignItems: 'end',
                    paddingBottom: '90px',
                    backdropFilter: 'blur(8px)',
                    WebkitBackdropFilter: 'blur(8px)'
                }}
            >
                <div
                    className="popup color-popup-mobile d-md-none"
                    style={{
                        position: 'relative',
                        transform: 'none',
                        top: 0,
                        left: 0,
                        maxWidth: '90%',
                        background: '#fff',
                        borderRadius: 12,
                        boxShadow: 'rgb(0 0 0 / 37%) 0px 0px 20px',
                        width: '100%',
                        padding: '24px 16px 0 16px',
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <ColoredGeneratePasswordIcon height={'30px'} width={'30px'} />
                            <span style={{ fontWeight: 600, fontSize: 18 }}>Generate Password</span>
                        </div>
                    </div>
                    <div style={{ color: '#888', fontSize: 14, marginBottom: 18 }}>
                        <div>
                            <div>
                                Generate a compliant, high-strength password for secure access.
                            </div>
                        
                        </div>
                    </div>
                    <div className="form-group" style={{ marginBottom: 18 }}>
                        
                        
                        <div style={{ background: '#e0e0e0', borderRadius: '12px', padding: '10px 20px', height: '40px', position: 'relative' }}>
                            <div>
                                {generatedPassword}
                            </div>
                            <CopyToClipboard
                                text={generatedPassword}
                                onCopy={() => {
                                    toast.success('Password copied to clipboard!')
                                    handleSubmit(generatedPassword)
                                }}
                            >
                                <div
                                    className="client-portal-notification-modal-content-copy-button"
                                    style={{ cursor: 'pointer', top: '5px' }}
                                >
                                    Copy
                                </div>
                            </CopyToClipboard>
                            
                            
                            
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <button
                                className="btn btn-main-primary btn-block btn-outlined-main"
                                onClick={generateNewPassword}
                                style={{
                                    height: '40px'
                                }}
                            >
                                Generate Password
                            </button>
                        </div>
                    </div>
                    <div
                        className="btnarea"
                        style={{
                            position: 'sticky',
                            bottom: 0,
                            left: 0,
                            width: '100%',
                            background: '#fff',
                            padding: '16px 0 12px 0',
                            zIndex: 30,
                            display: 'flex',
                            gap: 10,
                            justifyContent: 'center',
                            marginTop: 'auto'
                        }}
                    >
                        <button
                            className="btn btn-main"
                            onClick={() => {
                                handleSubmit(generatedPassword)
                            }}
                        >
                            <FaSave /> Use Password
                        </button>
                        <button className="btn new-btn-error" onClick={handleClose}>
                            <FaTimes /> Close
                        </button>
                    </div>
                </div>
            </div>
        );
};

export default GeneratePasswordModal;
